import React, { forwardRef, useRef, useImperativeHandle, useState } from 'react';
import { Map, APILoader } from '@uiw/react-baidu-map';

import './index.module.less';

import {  BMAPKEY } from '@helpers/Constants';
// import { json } from './mapStyle';
interface IProps {
  children: React.ReactNode;
  center?: any;
  onMapLoad?: () => void;
  zoom?: number;
  maxZoom?: number;
  minZoom?: number;
  enablePinchToZoom?: boolean;
  enableDoubleClickZoom?: boolean;
  onZoomEnd?: () => void;
  onTouchStart?: () => void;
}

const BaseMap = (props: IProps, ref: any) => {
  const { center, zoom, minZoom, maxZoom,
    enablePinchToZoom = true,
    enableDoubleClickZoom = true, onZoomEnd = null,
    onTouchStart
  } = props;
  const mapRef = useRef(null);
  const [isFirstLoaded, setFirstLoaded] = useState(false);

  useImperativeHandle(ref, () => ({
    zoomIn,
    zoomOut,
    getMapRef: () => mapRef.current.map,
    getZoom
  }));

  const getZoom = () => {
    const instanceMap = mapRef.current.map;
    console.log(instanceMap, 'instanceMap');
    return instanceMap.getZoom();
  }

  const onLoad = () => {
    if(!isFirstLoaded) {
      setFirstLoaded(true);
      props.onMapLoad && props.onMapLoad();
    }
  }

  const zoomIn = () => {
    const instanceMap = mapRef.current.map;
    if (instanceMap) {
      instanceMap.setZoom(getZoom() + 1);
    }
  }
  const zoomOut = () => {
    const instanceMap = mapRef.current.map;
    if (instanceMap) {
      instanceMap.setZoom(getZoom() - 1);
    }
  }
  return (
    <APILoader akay={ BMAPKEY } version="2.0">
      <Map
        zoom={zoom || 17}
        maxZoom={ maxZoom || 19 }
        minZoom={ minZoom || 1 }
        center={center}
        // mapStyleV2={{styleJson: json}}
        ref={mapRef}
        onTilesLoaded={onLoad}
        enablePinchToZoom={ enablePinchToZoom }
        enableDoubleClickZoom={ enableDoubleClickZoom }
        enableHighResolution={ true }
        onZoomEnd={ onZoomEnd }
        onTouchStart={ onTouchStart }
      >
        { props.children }
      </Map>
    </APILoader>
  )
}

export default forwardRef(BaseMap);